import React, {PropTypes, Component} from 'react';
import { connect } from 'react-redux';
import shortid from 'shortid';
import { get, isEmpty, isEqual, isNil, map, omit, reduce } from 'lodash';
import LicenseStatus from './LicenseStatus';
import LicenseLapsed from './LicenseLapsed';
import Licenses from './Licenses';
import FlatButton from '../../../common/components/c_FlatButton';
import ButtonGroup from '../../../common/components/ButtonGroup';
import * as licenseApi from '../../../redux/actionCreators/async/v2/applicants/licenses';
import * as uiApi from '../../../redux/actionCreators/sync/ui';
import * as licenseStore from '../../../redux/actionCreators/sync/licenses';

const addButtonStyle = {
  display: 'inline-block',
  top: '35px',
  width: '165px',
  transition: 'color 450ms cubic-bezier(0.23, 1, 0.32, 1), border-color 450ms cubic-bezier(0.23, 1, 0.32, 1)'
};

@connect(store => ({
  labels        : get(store, 'labels.Application.background.licenses', {}),
  licenses      : get(store, 'licenses', {}),
  licenseStatus : get(store, 'staticData.applicantLicenseStatus', []),
  tempState     : get(store, 'tempState')
}), null, null, { withRef: true })
export default class LicensesContainer extends Component {
  static propTypes = {
    dispatch        : PropTypes.func.isRequired,
    updateTempState : PropTypes.func.isRequired,
    profile         : PropTypes.object.isRequired,
    tempState       : PropTypes.object.isRequired,
    staticData      : PropTypes.object,
    licenses        : PropTypes.object,
    licenseStatus   : PropTypes.array,
  }

  constructor(props) {
    super(props);

    this.state = {
      licenses : {}
    };
  }

  componentWillMount() {
    if (!isEmpty(this.props.licenses)) {
      this.loadLicenses(this.props.licenses);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps) {
      if (nextProps.licenses && !isEqual(nextProps.licenses, this.props.licenses)) {
        this.loadLicenses(nextProps.licenses);
      }
    }
  }

  loadLicenses(licenses) {
    const newState = this.newState();
    newState.licenses = licenses;
    this.setState(newState);
  }

  licenseStatus() {
    const { tempState, profile } = this.props;
    return get(tempState, 'profile.licenseStatus', get(profile, 'licenseStatus'));
  }

  willingToReinstate() {
    const { tempState, profile } = this.props;
    return get(tempState, 'profile.willingToReinstateLicense', get(profile, 'willingToReinstateLicense'));
  }

  newState() {
    return Object.assign({}, this.state);
  }

  newLicense(clientId) {
    return {
      clientId      : clientId || shortid.generate(),
      state         : null,
      licenseTypeId : null,
      licenseName   : null,
      renewalDate   : null
    };
  }

  saveLicense(license) {
    const { dispatch, profile } = this.props;
    if (license && license.licenseTypeId || license.licenseName) {
      dispatch(licenseApi.saveLicense(profile.id, license, (err) => {
          if (err) {
            return uiApi.warningToast(err.message);
          }

          const newState = this.newState();
          newState.licenses[license.clientId] = license;
          dispatch(licenseStore.updateApplicantLicenses(profile.id, newState.licenses));
        })
      );
    }
    else {
      const newState = this.newState();
      newState.licenses[license.clientId] = license;
    }
  }

  deleteLicense(clientId) {
    const { dispatch, profile } = this.props;
    if (clientId) {
      dispatch(licenseApi.deleteLicense(profile.id, clientId, (err) => {
          if (err) {
            return uiApi.warningToast(err.message);
          }

          const newState = this.newState();
          const { licenses } = newState;
          newState.licenses = omit(licenses, [clientId]);
          dispatch(licenseStore.updateApplicantLicenses(profile.id, newState.licenses));
        })
      );
    }
  }

  handleStatusChange = (event, value) => {
    const { updateTempState } = this.props;
    updateTempState('profile', 'licenseStatus', event, value);
  }

  handleProfileChange = (property) =>
    (event, value) => {
      const { updateTempState } = this.props;
      updateTempState('profile', property, event, value);
    }

  handleChange = (event, clientId, property, value) => {
    const newState = this.newState();
    const license = newState.licenses[clientId] || this.newLicense(clientId);
    license[property] = value;
    this.saveLicense(license);
  }

  handleToggle = (event, clientId, selected) => {
    if (!selected) {
      this.deleteLicense(clientId);
    }
  }

  handleAddLicense = () => {
    const newState = this.newState();
    const license = this.newLicense();
    newState.licenses[license.clientId] = license;
    this.setState(newState);
  }

  handleAddNewLicense = (item) => {
    const {value, name} = item;
    const newLicense = this.newLicense(value);
    newLicense.licenseName = name;
    this.saveLicense(newLicense);
  }

  handleRemoveLicense = (clientId) => {
    const newState = this.newState();
    const {licenses} = newState;
    if (licenses[clientId]) {
      this.deleteLicense(clientId);
    }
  }

  // This is here for backwards compatibility
  // Not using standard form validation because Accounting Tenant
  // Licenses operate differently than Insurance Tenant and this
  // approach seemed most reasonable at the time. This overrides
  // the validateForm defined in the Parent Component hierarchy
  validateForm = () => {
    const {licenses} = this.newState();
    const {licenseStatus} = this.props;
    const currentStatus = this.licenseStatus();
    const isLicensed = licenseStatus.find(s => s.subElement === 'Licensed');
    const isLapsed = licenseStatus.find(s => s.subElement === 'Lapsed');

    if (isLapsed && currentStatus === isLapsed.id) {
      return !isNil(this.willingToReinstate());
    }
    if (isLicensed && currentStatus === isLicensed.id) {
      const isValid = reduce(licenses, (valid, license) =>
        valid && (license.licenseName || license.licenseTypeId),
        true
      );
      return isValid && !isEmpty(licenses);
    }

    return true;
  }

  renderLapsed(state, props) {
    const statuses = props.licenseStatus;
    const isLapsed = statuses.filter(s => s.subElement === 'Lapsed')
                               .map(s => s.id);

    if (isLapsed.includes(this.licenseStatus())) {
      return (
        <div>
          <LicenseLapsed
            label={get(props.labels, 'willingToReinstateLicense')}
            value={this.willingToReinstate()}
            onChange={this.handleProfileChange('willingToReinstateLicense')}
          />
        </div>
      );
    }
  }

  renderLicenses(state, props) {
    const { licenseTypes } = props.staticData;
    const licenses = isEmpty(state.licenses) ? [this.newLicense()] : state.licenses;
    const statuses = props.licenseStatus;
    const isLicensed = statuses.filter(s => s.subElement === 'Licensed')
                               .map(s => s.id);

    if (!isEmpty(licenseTypes) && isLicensed.includes(this.licenseStatus())) {

      return (
        <div className='licenses'>
          <div>
            Please select and complete the information below for each <b>resident</b> license. If you have non-resident licenses, you can attach a copy in documents but do not include them here.<br/>
            After you complete entering your licenses please do the following:
            <ol className="terms-list">
              <li>Click on Save in the bottom right corner of the page</li>
              <li>Click on Documents and attach copies of your licenses</li>
              <li>Return to the license section and click on next to continue with your application</li>
            </ol>
            <Licenses
              licenses={licenses}
              staticData={props.staticData}
              labels={props.labels}
              onChange={this.handleChange}
              onRemove={this.handleRemoveLicense}
            />
            <FlatButton
              style={{...addButtonStyle}}
              label='Add License'
              onClick={this.handleAddLicense}
            />
          </div>
        </div>
      );

    }
    // if licenses are yes and there are no license types populated... allow them to enter
    else if (isEmpty(licenseTypes) && isLicensed.includes(this.licenseStatus())) {

      const items = [];
      const values = map(state.licenses, license => ({value: license.clientId, name: license.licenseName}));

      return (
        <div className='licenses'>
          <div>
            Please add any licenses you may have.
          </div>
          <ButtonGroup
            items={items}
            value={values}
            onToggle={this.handleToggle}
            onAdd={this.handleAddNewLicense}
          />
        </div>
      );
    }
  }

  render() {
    return (
      <div className={'licenses-container application-section-container expanded-accordion-content clearfix'}>
        <div className={'form-heading'}>Licenses</div>
        <div className={'formText'}>{get(this.props, 'labels.formText')}</div>
        <LicenseStatus
          statuses={this.props.licenseStatus}
          value={this.licenseStatus()}
          onChange={this.handleStatusChange}
        />
        <div className={'subElement-container'}>
          {this.renderLicenses(this.state, this.props)}
          {this.renderLapsed(this.state, this.props)}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/applicant/LicensesForm/LicensesContainer.js